interface ButtonProps {
  text: string
  onClick?: () => void
  disabled?: boolean
  type?: 'primary' | 'secondary'
  className?: string
  icon?: React.ReactNode
}

export const Button = ({
  text,
  onClick: handleClick,
  disabled = false,
  type = 'primary',
  className = '',
  icon,
}: ButtonProps) => {
  const styles = {
    primary: 'text-white bg-black hover:bg-[#6E6E6E] focus:bg-[#505050] disabled:bg-[#D4D4D4] disabled:text-[#6E6E6E]',
    secondary: 'border border-solid border-black hover:bg-[#D4D4D4] focus:bg-[#BDBDBD] disabled:bg-[#B6B6B6]',
  }

  return (
    <button
      disabled={disabled}
      className={`font-TCCCText flex items-center text-14 leading-[22px] font-bold py-2 px-[18px] rounded-[40px]  ${styles[type]} ${className}`}
      onClick={() => handleClick && handleClick()}
    >
      {text}
      {icon}
    </button>
  )
}
